import React from "react";
import ProductChargePanel from "./ProductChargePanel";
import ProductServicesPanel from "./ProductServicesPanel";
import Switch from "../Switch/Switch";
import DateHelper from "../DateHelper/DateHelper";
import DatePickerInput from '../DatePickerInput/DatePickerInput';
import NumberInput from "../NumberInput/NumberInput";



class ProductDetails extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      collapseDetails: this.props.collapseDetails || false,
    }
    this.showDetails = this.showDetails.bind(this);
    this.allowBookingAddOnChange = this.allowBookingAddOnChange.bind(this);
    this.allowQuantityChange = this.allowQuantityChange.bind(this);
    this.allowPortalQuantityChange = this.allowPortalQuantityChange.bind(this);
    this.showInCustomerPortalChange = this.showInCustomerPortalChange.bind(this);
    this.onChangeCollectAmountAtBooking = this.onChangeCollectAmountAtBooking.bind(this);
  }

  render() {
    return (
      <div>
        {this.renderProduct(this.props.product)}
      </div>
    )
  }

  renderProduct(product, idx) {
    if (this.state.collapseDetails && product.id > 0) {
      return (
        <div
          key={product && product.id && idx ? (product.id + (product.name || '')) || idx : null} className="product">
          <div className="row">
            {this.props.read_only != true && this.props.remove ? <div className="col-sm-2 col-remove text-right pull-right"><button type="button" className={"btn btn-secondary " + (this.props.mode != 'single' && product.id > 0 ? null : 'btn-form')} onClick={this.props.removeProduct.bind(null, idx)}>{I18n.t('remove')}</button></div> : null}
          </div>
          <div className="row">
            <div className="col-md-4">
              <label>{`${I18n.t('code')}*`}</label>
              <div>{product.code}</div>
            </div>
            <div className="col-md-4">
              <label>{`${I18n.t('name')}*`}</label>
              <div>{product.name}</div>
            </div>
            {
              this.state.collapseDetails && product.default_assigned_to
                ? <div className="col-md-5">
                  <label>{`${I18n.t('default_assigned_to')}`}</label>
                  <div>{product.default_assigned_to.name}</div>
                </div>
                : null
            }
          </div>
          <br />
          <div className="row">
            <div className="col-md-4">
              <a className="show-product-details" onClick={this.showDetails}>{I18n.t('show_details')} <span className="toggle-arrow arrow-right"></span> </a>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div key={product && product.id && idx ? (product.id + (product.name || '')) || idx : null} className="product">
          <div className="row">
            {this.props.read_only != true && this.props.remove ? <div className="col-sm-2 col-remove text-right pull-right"><button type="button" className={"btn btn-secondary " + (this.props.mode != 'single' && product.id > 0 ? null : 'btn-form')} onClick={this.props.removeProduct.bind(null, idx)}>{I18n.t('remove')}</button></div> : null}
          </div>
          <div className="row">
            <div className="col-md-3">
              <label>{`${I18n.t('code')}*`}</label>
              <div className="form-group">
                {this.props.read_only || (this.props.mode != 'single' && product.id > 0) ? <div>{product.code}</div> : <input className={this.props.renderFieldClasses('code')} value={product && product.code ? product.code : ''} placeholder={I18n.t('code')} onChange={(e) => this.props.onChangeInput(e, 'code')} />}
                {this.props.renderFieldErrors('code')}
              </div>
            </div>
            <div className="col-md-3">
              <label>{`${I18n.t('name')}*`}</label>
              <div className="form-group">
                {this.props.read_only || (this.props.mode != 'single' && product.id > 0) ? <div>{product.name}</div> : <input className={this.props.renderFieldClasses('name')} value={product && product.name ? product.name : ''} placeholder={I18n.t('name')} onChange={(e) => this.props.onChangeInput(e, 'name')} />}
                {this.props.renderFieldErrors('name')}
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>{I18n.t('status')}</label>
                <select name="status" value={this.props.product.status || ''} className="form-control" onChange={this.props.onChangeStatus}>
                  <option value="disabled">{I18n.t('Disabled')}</option>
                  <option value="enabled">{I18n.t('enabled')}</option>
                </select>
              </div>
            </div>

            <div className="col-md-4 ">
              <div className="form-group">
                <label>{I18n.t('description')}</label>
                {this.props.read_only || (this.props.mode != 'single' && product.id > 0) ? <div>{product.description}</div> : <textarea defaultValue={product && product.description ? product.description : ''} className="form-control" rows={2} onChange={(e) => this.props.onChangeInput(e, 'description')} />}
                {this.props.renderFieldErrors(product, 'description')}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>{I18n.t('start_date')} <span className="ss-help help" title={I18n.t('product_start_date_helper_text')}></span></label>
                <DatePickerInput
                  selectedDate={this.props.product.start_date}
                  dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                  onChange={this.props.onChangeStartDate}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>{I18n.t('end_date')} <span className="ss-help help" title={I18n.t('product_end_date_helper_text')}></span></label>
                <DatePickerInput
                  selectedDate={this.props.product.end_date}
                  dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
                  onChange={this.props.onChangeEndDate}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>{I18n.t('min_lead')} <span className="ss-help help" title={I18n.t('product_min_lead_helper_text')}></span></label>
                <NumberInput
                  name="minimum_lead"
                  className="form-control"
                  onChange={this.props.onChangeMinimumLead}
                  value={this.props.product.minimum_lead} />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>{I18n.t('max_lead')} <span className="ss-help help" title={I18n.t('product_max_lead_helper_text')}></span></label>
                <NumberInput
                  name="maximum_lead"
                  className="form-control"
                  onChange={this.props.onChangeMaximumLead}
                  value={this.props.product.maximum_lead} />
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-sm-4">
              {this.props.read_only || (this.props.mode != 'single' && product.id > 0) ? <div> <br /> <a className="show-product-details" onClick={this.showDetails}>{I18n.t('hide_details')} <span className="toggle-arrow arrow-down"></span> </a> </div> : null}
            </div>
          </div>
          <br />
          <div className="row bottom-spacer">
            <div className="col-md-6" >
              <div className="panel default-panel">
                <div className="panel-body">
                  <ProductChargePanel {...this.props} />
                </div>
              </div>
            </div>

            <div className="col-md-6" >
              <div className="panel default-panel">
                <div className="panel-body">
                  <ProductServicesPanel {...this.props} />
                </div>
              </div>
            </div>
          </div>


          <div className="row">
            <div className="col-md-6">
              <div className="panel default-panel">
                <div className="panel-body">
                  <h5 className="default-panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10}}>{I18n.t('booking_details')}</h5>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('show_as_booking_add_on')} <span className="ss-help help" title={I18n.t('show_as_booking_add_on_helper_text')}></span></label>
                        <Switch
                          onText="yes"
                          switchId="show-as-booking-add-on-switch"
                          offText="no"
                          value={this.props.product.show_as_booking_add_on}
                          name="show_as_booking_add_on"
                          onChange={this.allowBookingAddOnChange}
                        />
                      </div>
                    </div>
                    {
                      this.props.product.show_as_booking_add_on
                      ?
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>{I18n.t('quantity_allowed')} <span className="ss-help help" title={I18n.t('quantity_allowed_helper_text')}></span></label>
                          <Switch onText="yes" switchId="quantity-allowed-switch" offText="no" value={this.props.product.quantity_allowed} name="quantity_allowed" onChange={this.allowQuantityChange}  />
                        </div>
                      </div>
                      :
                      null
                    }
                  </div>
                  <div className="row">
                    {
                      this.props.product.show_as_booking_add_on
                      ?
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>{I18n.t('collect_amount_at_booking')} <span className="ss-help help" title={I18n.t('collect_amount_at_booking_helper_text')}></span></label>
                          <Switch onText="yes" switchId="collect-amount-switch" offText="no" value={this.props.product.collect_amount_at_booking} name="collect_amount_at_booking" onChange={this.onChangeCollectAmountAtBooking}  />
                        </div>
                      </div>
                      :
                      null
                    }

                  </div>

                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="panel default-panel">
                <div className="panel-body">
                  <h5 className="default-panel-heading-text" style={{borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10}}>{I18n.t('customer_portal')}</h5>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>{I18n.t('show_in_customer_portal')} <span className="ss-help help" title={I18n.t('show_in_customer_portal_on_helper_text')}></span></label>
                        <Switch onText="yes" switchId="show-in-customer-portal-switch" offText="no" value={this.props.product.show_in_customer_portal} name="show_in_customer_portal" onChange={this.showInCustomerPortalChange}  />
                      </div>
                    </div>
                    {
                      this.props.product.show_in_customer_portal
                      ?
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>{I18n.t('quantity_allowed')} <span className="ss-help help" title={I18n.t('quantity_allowed_helper_text')}></span></label>
                          <Switch onText="yes" switchId="portal-quantity-allowed-switch" offText="no" value={this.props.product.portal_quantity_allowed} name="portal_quantity_allowed" onChange={this.allowPortalQuantityChange}  />
                        </div>
                      </div>
                      :
                      null
                    }
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      );
    }
  };

  showDetails() {
    this.setState({
      collapseDetails: !this.state.collapseDetails,
    })
  };


  allowBookingAddOnChange(input) {
    this.props.onChangeSwitch('show_as_booking_add_on', input.target.checked)
  };

  onChangeCollectAmountAtBooking(input) {
    // console.log("input.target.checked", input.target.checked);
    this.props.onChangeSwitch('collect_amount_at_booking', input.target.checked)
  }

  allowQuantityChange(input) {
    this.props.onChangeSwitch('quantity_allowed', input.target.checked)
  };
  allowPortalQuantityChange(input) {
    this.props.onChangeSwitch('portal_quantity_allowed', input.target.checked)
  };

  showInCustomerPortalChange(input) {
    this.props.onChangeSwitch('show_in_customer_portal', input.target.checked)
  };

};

export default ProductDetails
